import { useId } from 'react';
import { SvgIcon } from '../SvgIcon';

export const DonationSurveyIcon = ({
	fillColor = '#C6CCD7',
	width = 20,
	height = 20,
}: {
	fillColor?: string;
	width?: number;
	height?: number;
}) => {
	const id = useId();

	return (
		<SvgIcon width={width} height={height} viewBox='0 0 20 20'>
			<g id={`${id}-Page-1`} stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
				<g id={`${id}-Updated-Survey-Icons`} transform='translate(-315, -156)' fill={fillColor}>
					<g id={`${id}-Donation-Icon-Copy`} transform='translate(315, 156)'>
						<path
							d='M4.16666667,3.33406961 L1.66666667,3.33406961 L1.66666667,1.6670348 L4.16666667,1.6670348 L4.16666667,3.33406961 Z M16.6666667,3.33406961 L10,3.33406961 L10,1.6670348 L16.6666667,1.6670348 L16.6666667,3.33406961 Z M5.83333333,1.6670348 L8.33333333,1.6670348 L8.33333333,3.33406961 L5.83333333,3.33406961 L5.83333333,1.6670348 Z M1.66666667,5.00110441 L16.6666667,5.00110441 L16.665,9.16452383 L18.3333333,9.16452383 L18.3333333,1.6670348 C18.3333333,0.747665109 17.5858333,0 16.6666667,0 L1.66666667,0 C0.7475,0 0,0.747665109 0,1.6670348 L0,15.0033132 C0,15.9235164 0.7475,16.670348 1.66666667,16.670348 L8.33333333,16.670348 L8.33333333,15.0033132 L1.66666667,15.0033132 L1.66666667,5.00110441 Z'
							id={`${id}-Fill-1761`}
						/>
						<path
							d='M15,18.1754304 C13.815,17.3710861 11.6666667,15.6140314 11.6666667,14.1653782 C11.6666667,13.6644342 11.8291667,12.4983434 13.3333333,12.4983434 C13.7075,12.4983434 14.1666667,12.9576115 14.1666667,13.3318608 C14.1666667,13.7919624 14.54,14.1653782 15,14.1653782 C15.46,14.1653782 15.8333333,13.7919624 15.8333333,13.3318608 C15.8333333,12.9576115 16.2925,12.4983434 16.6666667,12.4983434 C18.1708333,12.4983434 18.3333333,13.6644342 18.3333333,14.1653782 C18.3333333,15.6140314 16.185,17.3710861 15,18.1754304 M16.6666667,10.8313086 C16.0541667,10.8313086 15.4566667,11.1080364 15,11.5364643 C14.5433333,11.1080364 13.9458333,10.8313086 13.3333333,10.8313086 C11.3391667,10.8313086 10,12.170771 10,14.1653782 C10,17.0543495 14.1033333,19.5999116 14.5708333,19.880807 C14.7033333,19.9608247 14.8516667,20 15,20 C15.1483333,20 15.2966667,19.9608247 15.4291667,19.880807 C15.8966667,19.5999116 20,17.0543495 20,14.1653782 C20,12.170771 18.6608333,10.8313086 16.6666667,10.8313086'
							id={`${id}-Fill-1762`}
						/>
					</g>
				</g>
			</g>
		</SvgIcon>
	);
};
